import { DEFAULT_LOCATION, GOOGLE_MAP_ZOOM } from '@/data/constants/storeLocator';

export const calculateMapCenterZoom = (
	filteredStores: {
		lat: number;
		lng: number;
	}[]
) => {
	if (filteredStores.length === 0) {
		return {
			center: DEFAULT_LOCATION,
			zoom: GOOGLE_MAP_ZOOM.INIT,
		};
	}

	let minLat = filteredStores[0].lat;
	let maxLat = filteredStores[0].lat;
	let minLng = filteredStores[0].lng;
	let maxLng = filteredStores[0].lng;

	filteredStores.forEach((store) => {
		if (store.lat < minLat) minLat = store.lat;
		if (store.lat > maxLat) maxLat = store.lat;
		if (store.lng < minLng) minLng = store.lng;
		if (store.lng > maxLng) maxLng = store.lng;
	});

	const centerLat = (minLat + maxLat) / 2;
	const centerLng = (minLng + maxLng) / 2;

	const latDiff = maxLat - minLat;
	const lngDiff = maxLng - minLng;
	const maxDiff = Math.max(latDiff, lngDiff);

	const zoom = Math.floor(8 - Math.log(maxDiff) / Math.log(2));

	return {
		center: { lat: centerLat, lng: centerLng },
		zoom,
	};
};
